module.exports = __webpack_public_path__ + "img/Proveedores.3585b4a9.svg";